export { ExpandingTextArea } from './ExpandingTextArea';